import instance from "./request";

//模板配置详情
export const fileInfo = () => instance.get('/files/fileConfig')

//修改模板配置
export const fileInfoSet = (data) => instance.post('/files/fileConfigSet', data)

//更新打印二维码时间
export const setcodetime = (data) => instance.post('/files/setcodetime', data)

//空白模板详情
export const filesBlankInfo = (id) => instance.get('/filesBlank/info/' + id)

//新增空白模板
export const filesBlankAdd = (data) => instance.post('/filesBlank/add', data)

//编辑空白模板
export const filesBlankEdit = (data) => instance.post('/filesBlank/edit', data)
